import { Button } from '@/shared/components/Button';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getLocalStorageData } from '@/utils/LocalStorage';
import { MainLoading } from '@/shared/components/Skeleton/MainLoading';
import { clearAllStorage } from '@/utils/clearBrowser';

const NotFound404 = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state?.auth);
  const currentLocation = useLocation();
  const { allowedModulePermissions } = useSelector((state) => state?.permissionsStorage);
  const [loading, setLoading] = useState(true);
  const getToken = JSON.parse(getLocalStorageData('token'));
  let token = getToken?.currentUser?.token;

  useEffect(() => {
    if (token) {
      if (allowedModulePermissions?.length > 0) {
        const found = allowedModulePermissions?.some((item) => {
          if (item?.path == '/tickets/') {
            return true;
          }
        });
        if (!found) {
          setLoading(false);
          const parsedPath = parseString(allowedModulePermissions[0]?.path);
          navigate(parsedPath);
        } else {
          setLoading(false);
          if (isLoggedIn) {
            return navigate(currentLocation.pathname);
          }
        }
      }
      setLoading(false);
    } else {
      setLoading(false);
      navigate('/login');
    }
  }, [allowedModulePermissions]);

  const parseString = (inputStr) => {
    const parts = inputStr.split('/').filter((part) => part !== '');
    const simplifiedPath = `/${parts[0]}/`;

    return simplifiedPath;
  };

  const handleReturnHomeClick = async () => {
    if (!isLoggedIn) {
      await clearAllStorage();
      navigate('/login');
    } else {
      navigate('/tickets/');
    }
  };

  return loading ? (
    <MainLoading />
  ) : (
    <NotFoundContainer>
      <NotFountContent>
        <NotFoundImage
          src={`${import.meta.env.VITE_PUBLIC_URL}/404.webp`}
          alt='404'
          loading='lazy'
        />
        <NotFoundInfo>Ooops! The page you are looking for could not be found :(</NotFoundInfo>
        <Button
          variant='primary'
          onClick={handleReturnHomeClick}
        >
          Return to Home
        </Button>
      </NotFountContent>
    </NotFoundContainer>
  );
};

export default NotFound404;

// region STYLES

const NotFoundContainer = styled.div`
  text-align: center;
  height: 100vh;
  overflow: auto;
  display: flex;
  background: url(${import.meta.env.VITE_PUBLIC_URL}/404/bg_404.jpeg) no-repeat center;
  background-size: cover;

  button {
    margin: 0;
  }
`;

const NotFountContent = styled.div`
  margin: auto;
  padding: 10px;
`;

const NotFoundImage = styled.img`
  max-width: 500px;
  width: 100%;
`;

const NotFoundInfo = styled.h3`
  margin-bottom: 20px;
  margin-top: 90px;
`;

// endregion
